export default class AnnouncementsCardStyle {
    constructor(vertical = '') {
        this.vertical = vertical;
        this.styles = this.cardStyles();
        this.currentStyle = 0;
    }

    reset() {
        this.currentStyle = 0;
    }

    cardStyles() {
        switch (this.vertical) {
            case 'fintech':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'poppy'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'citrus'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'presidio'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'poppy'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'citrus'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'presidio'}
                ];
            case 'enterprise':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'deep-ocean'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'caribbean-green'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'dark-navy'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'electric-magenta'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'deep-ocean'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'caribbean-green'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'dark-navy'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'electric-magenta'}
                ];
            case 'seed':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'haight'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'tiber'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'games'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'haight'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'tiber'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'games'}
                ];
            case 'american-dynamism':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'darker-blue'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'neon-green'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'neon-green'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'darker-blue'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'neon-green'}
                ];
            case 'games':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'games'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'black'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'citrus'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'purple'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'games'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'black'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'citrus'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'purple'}
                ];
            case 'consumer':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'consumer-red'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'light-green'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'consumer-jade'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'consumer-pink'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'citrus'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'consumer-red'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'light-green'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'consumer-jade'}
                ];
            case 'growth':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'avocado'},
                    {pattern: 'images/card-pattern/pattern-c-5.svg', class: 'bayside'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'deep-ocean'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'deep-ocean'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'citrus'},
                    {pattern: 'images/card-pattern/pattern-c-5.svg', class: 'avocado'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'bayside'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'deep-ocean'}
                ];
            case 'bio-health':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'bayside'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'avocado'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'presidio'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'bayside'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'marina'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'avocado'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'presidio'}
                ];
            case 'clf':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'dark-green-1'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'dark-green'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'light-yellow'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'games'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'dark-green-1'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'dark-green'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'light-yellow'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'games'}
                ];
            case 'txo':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'citrus'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'haight'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'games'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'black'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'citrus'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'haight'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'games'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'black'}
                ];
            case 'crypto':
                return [
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'lime'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'magenta'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'orange'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'black'},
                    {pattern: 'images/card-pattern/pattern-c-1.svg', class: 'lime'},
                    {pattern: 'images/card-pattern/pattern-c-2.svg', class: 'magenta'},
                    {pattern: 'images/card-pattern/pattern-c-3.svg', class: 'orange'},
                    {pattern: 'images/card-pattern/pattern-c-4.svg', class: 'black'}
                ];
            default:
                return [
                    {pattern: 'images/pattern-1.svg', class: 'poppy'},
                    {pattern: 'images/pattern-2.svg', class: 'bayside'},
                    {pattern: 'images/pattern-3.svg', class: 'avocado'},
                    {pattern: 'images/pattern-4.svg', class: 'marina'},
                    {pattern: 'images/pattern-1.svg', class: 'poppy'},
                    {pattern: 'images/pattern-6.svg', class: 'bayside'},
                    {pattern: 'images/pattern-7.svg', class: 'avocado'},
                    {pattern: 'images/pattern-8.svg', class: 'marina'}
                ];
        }
    }

    getCardStyleByIndex(index) {
        console.log('get style by id', index)
        const style = this.styles[index % this.styles.length];
        style.patternURL = `${window.assets_url}/${style.pattern}`;
        return style;
    }

    getNextCardStyle() {
        return this.getCardStyleByIndex(this.currentStyle++);
    }
}
